import axios from 'axios';
import { findBestMatch } from 'string-similarity';
import { baseURL, proxyurl } from './requestHelper';
import {getBPheader, getIdBySKU, getInventoryById} from './brightpearl';
import { getSwatchURL } from './ashlinDesign';
const BASE_URL = proxyurl + "https://api.bigcommerce.com/stores";

export const getStoreInfo =async(brand)=> {
    const res = await axios.get(`${baseURL}api/bigcommerce/${brand}`);
    const header = res.data;
    return{
        "store_hash":header.Store_Hash,
        "headers": {
            "Content-Type": "application/json",
            "Authorization": header.Authorization,
            "X-Auth-Token": header.X_Auth_Token,
            "X-Auth-Client": header.X_Auth_Client,
            "Accept": "application/json"
        }
    };


};
const getBigCommerceCategories = async (storeInfo)=>{
    return await axios.get(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/categories?limit=100`,{headers:storeInfo.headers});
};
const mapBigCommerceCategory = (value,list)=>{
    return findBestMatch(value,list).bestMatch.target;
};
const findBestMatchColor = (value,colorList)=>{
  const list = colorList.map(c=>c.name);
  const match = findBestMatch(value.toUpperCase(),list).bestMatch.target;
  const color = colorList.filter(c=>c.name===match);
  return color[0].value;
};
export const findTheBestCategory = async (storeInfo,title)=>{
    const categoryIds = [];
    const res = await getBigCommerceCategories(storeInfo);
    const list = res.data.data.map(cate=>cate.name);
    const matches = mapBigCommerceCategory(title,list);
    const childCategory=res.data.data.filter(cate=>cate.name === matches)[0];
    categoryIds.push(childCategory.id);
    if(childCategory.parent_id !== undefined){
        const parentCategory = res.data.data.find(c=>c.id===childCategory.parent_id);
        if(parentCategory!==undefined) {
            categoryIds.push(parentCategory.id);
            if (parentCategory.parent_id !== undefined && parentCategory.parent_id !== parentCategory.id) {
                const superParentCategory = res.data.data.find(p => p.id === parentCategory.parent_id);
                if (superParentCategory !== undefined) {
                    categoryIds.push(superParentCategory.id);
                }
            }
        }
    }
    return categoryIds;
};
export const findProductById = async (storeInfo,id)=>{
    return await axios.get(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${id}`,{headers:storeInfo.headers});
};
export const getAllProducts = async(storeInfo,num)=>{
    return await axios.get(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products?page=${num}`,{headers:storeInfo.headers});
};
export const findProductBySku = async (storeInfo,sku)=>{
    let bgSku = sku.split('-');
    bgSku.pop();
    bgSku = bgSku.join('-');
    //console.log(bgSku);
    return await axios.get(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products?sku=${bgSku}`,{headers:storeInfo.headers});
};
export const getVariant = async (storeInfo,product_id,variant_id)=>{
    return await axios.get(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/variants/${variant_id}`,{headers:storeInfo.headers});
};
export const getVariants = async (storeInfo,product_id)=>{
    return await axios.get(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/variants`,{headers:storeInfo.headers});
};
export const getVariantOptions = async (storeInfo,product_id)=>{
    return await axios.get(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/options`,{headers:storeInfo.headers});
};

export const productDescription=(product,bulkPriceRules)=>{
    let offerStatus = product.Status==='SPECIAL ORDER on Web site'?`<h3 >SPECIAL ORDER [ MINIMUM QUANTITIES APPLY ] </h3>`:"";
    let features = '';
    let details = '';
    let bulkPrices='';
    let imprintedPrice ='<table style="border:1px solid black;border-collapse:collapse;width: 100%"><tr>';
    let imprintedPriceUs ='<tr>';
    let imprintedPriceCa ='<tr>';
    if(product.keyFeature1 !==""){
        features += `<li>${product.keyFeature1}</li>`
    }
    if(product.keyFeature2 !==""){
        features += `<li>${product.keyFeature2}</li>`
    }
    if(product.keyFeature3 !==""){
        features += `<li>${product.keyFeature3}</li>`
    }
    if(product.keyFeature4 !==""){
        features += `<li>${product.keyFeature4}</li>`
    }
    if(product.keyFeature5 !==""){
        features += `<li>${product.keyFeature5}</li>`
    }
    if(!product.Material.includes("Vegan"))
        features += `<li>Featuring 100% ${product.Material} full grain leather. Our products are crafted from 100% genuine leather. This premium leather shows off a natural range of shades and textures. We use full grain leather, which is the ultimate quality in leather available.</li>`

    details += `<li>Closed Dimensions in cm's : ${product.HeightCm} cm x ${product.WidthCm} cm x ${product.DepthCm} cm</li>`;
    details += `<li>Closed Dimensions in inch's : ${(product.HeightCm*0.393701).toFixed(2)} inches x ${(product.WidthCm*0.393701).toFixed(2)} inches x ${(product.DepthCm*0.393701).toFixed(2)} inches</li>`;
    bulkPriceRules.forEach(price=>{
       let imprintedFee = parseFloat(price.amount) * 0.05;
       if(imprintedFee < 1){
           imprintedFee = 1;
       }
       if(imprintedFee > 8){
           imprintedFee = 8;
       }
       const additionalComponentFee = (product.Components - 1) * 1.00;
       const imprintedPriceFinal = parseFloat(price.amount) + imprintedFee + additionalComponentFee;
       bulkPrices += `<li>Buy ${price.quantity_min===2500?`${price.quantity_min}+`:`${price.quantity_min} - `}  ${price.quantity_max===0?"":price.quantity_max} and pay only ${price.amount} each</li>`;
       imprintedPrice +=`<th style="border:1px solid black;border-collapse:collapse;text-align:center;">${price.quantity_min===2500?`QTY [C]:<br/> ${price.quantity_min}+`:`QTY [C]:<br/> ${price.quantity_min} - `}  ${price.quantity_max===0?"":price.quantity_max}</th>`;
       imprintedPriceUs += `<td style="border:1px solid black;border-collapse:collapse">USD: ${imprintedPriceFinal.toFixed(2)}</td>`;
       imprintedPriceCa += `<td style="border:1px solid black;border-collapse:collapse">CAD: ${(imprintedPriceFinal/0.85).toFixed(2)}</td>`;
    });
    imprintedPrice += '</tr>'+imprintedPriceUs +'</tr>'+imprintedPriceCa+'</tr></table>';
    let bulkPricing ="";
    if(product.Brand!=="Ashlin®"){
        bulkPricing = `<h3>BULK PRICES</h3><ul>${bulkPrices}</ul>`;
    }

    const imprintedTable = bulkPriceRules.length !==0 ?`<h3>IMPRINTED PRICING - STANDARD DELIVERY [C]</h3>${imprintedPrice}<p style="font-style: italic; font-weight: bold">**DIE COST & SETUP For standard sized dies: ( up to 4 square inches ) = $98.50 (G)**</p>${bulkPricing}`:"";
    return `<div>` +
            `${product.ExtendedDescription}`+
            `<h3>FEATURES:</h3>` +
            `<ul>${features}</ul>`+
            `<h3>PRODUCT DETAILS:</h3>` +
            `<ul>${details}</ul>`+
            `${offerStatus}`+ imprintedTable +
            `</div>`
};
export const calculateBulKPrice = async (p,tier)=>{
    const tierValueRes = await axios.get(`${baseURL}api/Discount/${tier}`);
    const tierValue = tierValueRes.data;
    const price = p*0.85;//*1.05;
    return {
        "Base":(price).toFixed(2),
        "Bulk":[
            {
                "quantity_min":2,
                "quantity_max":5,
                "type": "fixed",
                "amount":(tierValue._1CStandardDelivery * (price-0.01)).toFixed(2)
            },
            {
                "quantity_min":6,
                "quantity_max":11,
                "type": "fixed",
                "amount":(tierValue._6CStandardDelivery * (price-0.01)-0.01).toFixed(2)
            },
            {
                "quantity_min":12,
                "quantity_max":23,
                "type": "fixed",
                "amount":(tierValue._6CStandardDelivery * (price-0.02)-0.01).toFixed(2)
            },
            {
                "quantity_min":24,
                "quantity_max":50,
                "type": "fixed",
                "amount":(tierValue._24CStandardDelivery * (price-0.01)).toFixed(2)
            },
            {
                "quantity_min":51,
                "quantity_max":99,
                "type": "fixed",
                "amount":(tierValue._50CStandardDelivery * price -0.01).toFixed(2)
            },
            {
                "quantity_min":100,
                "quantity_max":249,
                "type": "fixed",
                "amount":(tierValue._100CStandardDelivery * price -0.01).toFixed(2)
            },
            {
                "quantity_min":250,
                "quantity_max":499,
                "type": "fixed",
                "amount":(tierValue._250CStandardDelivery * price -0.01).toFixed(2)
            },
            {
                "quantity_min":500,
                "quantity_max":999,
                "type": "fixed",
                "amount":(tierValue._500CStandardDelivery * price -0.01).toFixed(2)
            },
            {
                "quantity_min":1000,
                "quantity_max":2499,
                "type": "fixed",
                "amount":(tierValue._1000CStandardDelivery * price -0.01).toFixed(2)
            },
            {
                "quantity_min":2500,
                "quantity_max":0,
                "type": "fixed",
                "amount":(tierValue._2500CStandardDelivery * price -0.01).toFixed(2)
            }
        ]
    };

};
export const filterBulkPriceRule = (bulk,min)=>{
    return bulk.filter(rule=>rule.quantity_min>=min);
};
export const addProduct = async (brand,product)=>{
    const storeInfo =await getStoreInfo(brand);
    const findProductRes = await findProductBySku(storeInfo,product.Sku);
    if(findProductRes.data.data.length !==0){
        //Product Exist
        const design = findProductRes.data.data[0];
        const findVariantOptionsRes = await getVariantOptions(storeInfo,design.id);
        if(findVariantOptionsRes.data.data[0] !== undefined){
            console.log("Add New Product to Design!");
            const variantOptions = findVariantOptionsRes.data.data[0];
            const bgSku = product.Sku.split('-');
            const swatchName = `${bgSku[1]}-${bgSku[2]}`;
            //console.log(swatchName);
            const swatchImageURL = await getSwatchURL(swatchName);
            let valueData;
            if(swatchImageURL !=="Not Found"){
                valueData = {"image_url": `${swatchImageURL}`};//:{"colors": [`${colors}`]};
            }else if(product.ColorR !==undefined && product.ColorG !==undefined && product.ColorB !==undefined) {
                valueData = {"colors": [`${rgbToHex(parseInt(product.ColorR), parseInt(product.ColorG), parseInt(product.ColorB))}`]}
            }
            else{
                //find swatch
                //console.log(product);
                valueData = {"colors": [`${stringToHex(product.Color)}`]};
            }
            const variantOptionsOldValue = variantOptions.option_values.map(i=>i);
            variantOptions.option_values.push({
                "label": product.Color,
                "sort_order": (variantOptions.option_values.length+1),
                "value_data": valueData,
                "is_default": false
            });
            const variantOptionUpdateRes = await updateVariantOption(storeInfo,design.id,variantOptions.id,variantOptions);
            const variantOptionNewValue =variantOptionUpdateRes.data.data.option_values;
            const addedVariantOptionValue = await variantOptionNewValue.filter(i=>{
                if(variantOptionsOldValue.find(v=>v.id===i.id)===undefined){
                    return i;
                }
            });
            const optionValue = [];
            optionValue.push({
                "id":addedVariantOptionValue[0].id,
                "option_id": variantOptions.id
            });
            let mainImageRes;
            const imageDescription = product.Brand + " DESIGNER | " + product.Name + " " + product.ShortDescription.replace('.','')+" "+product.Sku;
            if(product.Urls.HostingerUrls.MAIN[0]!==undefined) {
                mainImageRes = await addImage(storeInfo, design.id, false, 1, imageDescription, product.Urls.HostingerUrls.MAIN[0]);
            }
            const imagesRes =await product.Urls.GoogleDriveUrls.BASE.map(async (img,index)=>{
                return await addImage(storeInfo,design.id,false,3,imageDescription+` BASE ${index}`,img);
            });
            const imagesModelRes =await product.Urls.GoogleDriveUrls.MODEL.map(async (img,index)=>{
                return await addImage(storeInfo,design.id,false,5,imageDescription+` MODEL ${index}`,img);
            });
            const imagesLIFERes =await product.Urls.GoogleDriveUrls.LIFE.map(async (img,index)=>{
                return await addImage(storeInfo,design.id,false,7,imageDescription+` LIFE ${index}`,img);
            });

            const variantRes = await addVariant(storeInfo,product,design.id,optionValue,mainImageRes!==undefined? mainImageRes.data.data.url_standard:product.Urls.GoogleDriveUrls.MAIN[0]);
            await Promise.all([mainImageRes,imagesRes,imagesModelRes,imagesLIFERes,variantRes]).then(()=>{
            });
            return `${design.id}+${variantRes.data.data.id}`;
            // const imagesRes =await product.Urls.HostingerUrls.map(async (img,index)=>{
            //     return await addImage(storeInfo,design.id,(index===0),(index+1),product.ShortDescription,img);
            // });
            // await Promise.all([findVariantOptionsRes,variantOptionUpdateRes ,variantRes]).then(()=>{
            //     return `${design.id}+${variantRes.data.data.id}`;
            // });


        }else{
            //create new variant options, shouldn't come here
            console.log("Something wrong");
        }

    }else {
        //New Product
        //console.log("Add New Design!");
        return await addNewProduct(storeInfo,product);
    }

};
export const addNewProduct = async(storeInfo,product)=>{
    //const storeInfo = getStoreInfo(brand);
    const minOrder = product.MinOrder === undefined ? '1': product.MinOrder;
    const minImprintedOrder = product.ImprintedMinOrder === (undefined || 'N/A')?'N/A':product.ImprintedMinOrder;
    //let name = product.Brand + " DESIGNER | " + product.Name + " " + product.ShortDescription.replace('.','') + ` | ${product.Material} |`;
    let name = product.Brand + " DESIGNER | " + product.Name + " " + product.ShortDescription + ` | ${product.Material} |`;
    const bulkPrice = await calculateBulKPrice((product.Price * 1.05),product.PricingTier);
    const bulkPriceRules = filterBulkPriceRule(bulkPrice.Bulk,parseInt(minOrder,10));
    const imprintedBulkPriceRules = filterBulkPriceRule(bulkPrice.Bulk,parseInt(minImprintedOrder,10));
    const metaKeywords = product.MetaKeywords !== undefined? product.MetaKeywords.split(';'):[`${product.Brand}`];
    //Need to check brand
    let searchKeywords = "";
    let brand_id,warranty,bgSku,inventory_tracking,categorySearchWords,Sku;
    bgSku = product.Sku.split('-');
    const swatchName = `${bgSku[1]}-${bgSku[2]}`;
    //console.log(swatchName);
    const swatchImageURL = await getSwatchURL(swatchName);
    //console.log(swatchImageURL);
    if(swatchImageURL !=="Not Found"){
        product.SwatchURL = swatchImageURL;
    }
    bgSku.pop();
    bgSku = bgSku.join('-');
    if(product.Brand === "Ashlin®"){
        searchKeywords = product.Material.includes("Vegan")?"ASHLIN Vegan leather":"ASHLIN leather";
        brand_id = 1;
        warranty = "";
        inventory_tracking = "variant";
        categorySearchWords= product.Gender + product.DesignServiceFamilyDescription;
        Sku = bgSku;
        name = `${name} [${bgSku}]`;
    }else{
        searchKeywords = product.Material.includes("Vegan")?"POPPYBUZZ Vegan leather":"POPPYBUZZ leather";
        brand_id = 38;
        Sku =  product.Sku;
        inventory_tracking = "none";
        warranty ="POPPYBUZZ strives for full customer satisfaction, and we consistently and diligently work to improve our products and services. If for any reason you find yourself unsatisfied with our product(s), you may return the item(s) within 30 days of the order date. Your purchase will be fully refunded. The refund covers the full price of the purchased item, but it does not cover any shipping, handling, gift wrapping costs, or any other additional charges. Your refund will be in the same form of payment originally used for the purchase. The following conditions must be met for a successful refund: Your original receipt must be attached to your returned item(s), so we can process the refund. The packing slip that comes with your order is required as proof of purchase. All returned items must be unused/unworn in their original packaging with all paperwork, receipts, parts, and accessories. NON-RETURNABLE ITEMS Our Online Return Policy does not apply to all items. Please note that the following items will not be accepted for refund: Items that have been personalized with names or initials; Items that have been customized with a logo (of any type) or any other custom decoration. ADDITIONAL NOTES Please refer to our Return Instructions when returning your item. For returns to our warehouse, the postmark date of the return package will be considered the return date. Please note that we are not responsible for shipping, handling, gift wrap, and any other additional charges. Items that have been ordered with RUSH delivery (blank products) will be credited back not including the costs of the rush surcharged and associated shipping charges. Please request a Return Authorization Number (RA#) before sending back any item(s). Send a message to sales@poppybuzz.com requesting a refund, and we will reply within 1 business day with the RA# to be used on your documentation when sending back the item(s) to our office. When shipping to us from outside of Canada, we will send you the required paperwork to accompany the shipment. *Conditions may apply*";
        categorySearchWords = product.Gender + product.ShortDescription;
        name = `${name} [${product.Sku}]`;
    }
    const category = await findTheBestCategory(storeInfo,categorySearchWords);
    const data = {
        "name": name,
        "type": "physical",
        "sku": Sku,
        "description": productDescription(product,imprintedBulkPriceRules),
        "weight": (product.WeightGrams/1000).toFixed(2),
        "width": product.WidthCm,
        "depth": product.DepthCm,
        "height": product.HeightCm,
        "price": bulkPrice.Base,
        "categories": category,
        "brand_id": brand_id,
        // "inventory_level": 10,
        // "inventory_warning_level": 10,
        "inventory_tracking": inventory_tracking,
        // "fixed_cost_shipping_price": 8,
        "is_free_shipping": false,
        "is_visible": true,
        "is_featured": false,
        "related_products": [
            -1
        ],
        "bin_picking_number": "",
        "layout_file": "product.html",
        // "upc": "1234567890",
        "search_keywords": searchKeywords,
        "availability": "available",
        "gift_wrapping_options_type": "any",
        "gift_wrapping_options_list": [

        ],
        // "sort_order": 0,
        "condition": "New",
        "is_condition_shown": true,
         "order_quantity_minimum": parseInt(minOrder,10),
        // "order_quantity_maximum": 0,
        "meta_keywords": metaKeywords,
        // "view_count": 0,
        // "preorder_release_date": 0,
        "is_preorder_only": false,
        "is_price_hidden": false,
        "custom_url": {
            "url": `/${name.replace(/[^a-zA-Z0-9 '"]/g, '').replace(/ /g,'-')}${product.Sku}/`,
            "is_customized": true
        },
        "open_graph_type": "product",
        "custom_fields": [
            // {
            //     "name": "Release year",
            //     "value": "1987"
            // }
        ],
        "bulk_pricing_rules": bulkPriceRules,
        "warranty":warranty
    };
    //console.log(data);
    const addProductRes = await axios.post(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products`,data,{headers:storeInfo.headers});
    let mainImageRes = undefined;
    const imageDescription = product.Brand + " DESIGNER | " + product.Name + " " + product.ShortDescription.replace('.','')+" "+product.Sku;
    if(product.Urls.HostingerUrls.MAIN[0]!==undefined) {
       mainImageRes = await addImage(storeInfo, addProductRes.data.data.id, true, 1, imageDescription, product.Urls.HostingerUrls.MAIN[0]);
    }

    const imagesRes =await product.Urls.GoogleDriveUrls.BASE.map(async (img,index)=>{
        return await addImage(storeInfo,addProductRes.data.data.id,false,3,imageDescription+` BASE ${index}`,img);
    });
    const imagesModelRes =await product.Urls.GoogleDriveUrls.MODEL.map(async (img,index)=>{
        return await addImage(storeInfo,addProductRes.data.data.id,false,5,imageDescription+` MODEL ${index}`,img);
    });
    const imagesLIFERes =await product.Urls.GoogleDriveUrls.LIFE.map(async (img,index)=>{
        return await addImage(storeInfo,addProductRes.data.data.id,false,7,imageDescription+` LIFE ${index}`,img);
    });
    const imagesGROUPRes =await product.Urls.GoogleDriveUrls.GROUP.map(async (img,index)=>{
        return await addImage(storeInfo,addProductRes.data.data.id,false,9,imageDescription+` GROUP ${index}`,img);
    });
    if(product.Brand === "Ashlin®"){
        const variantOpRes = await addVariantOption(storeInfo,product,addProductRes.data.data.id,null);
        const optionValue = [];
        optionValue.push({
            "id":variantOpRes.data.data.option_values[0].id,
            "option_id": variantOpRes.data.data.id
        });

        const variantRes = await addVariant(storeInfo,product,addProductRes.data.data.id,optionValue,mainImageRes!==undefined? mainImageRes.data.data.url_standard:product.Urls.GoogleDriveUrls.MAIN[0]);
        await Promise.all([mainImageRes,imagesRes,variantOpRes,variantRes]).then(()=>{
        });
        return `${addProductRes.data.data.id}+${variantRes.data.data.id}`;
    }else{
        const colorListRes = await axios.get(`${baseURL}api/LegacySku/color/${bgSku}`);
        //const variantOpRes = await addVariantOption(storeInfo,product,addProductRes.data.data.id,colorListRes.data);
        const variantOpRes = await addVariantOption(storeInfo,product,addProductRes.data.data.id,null);
        await Promise.all([imagesRes,colorListRes ,variantOpRes,imagesModelRes,imagesLIFERes,imagesGROUPRes]).then(()=>{
        });
        return `${addProductRes.data.data.id}+Poppybuzz`;
    }
};
export const addVariant = async (storeInfo,item,product_id,optionValue,url)=>{

    const BPHeaders = await getBPheader();
    const brightPearlId = await getIdBySKU(item.Sku,BPHeaders);
    let inventory = 0;
    if(!isNaN(brightPearlId)){
        inventory = await getInventoryById(brightPearlId);
    }
    //console.log(inventory);
    const data = {
        //"cost_price": 3,
        //"price": 50.99,
        // "sale_price": 45,
        // "retail_price": 50.99,
        //"weight": 1,
        //"width": 4,
       // "height": 14.6,
        //"depth": 22,
        // "is_free_shipping": false,
        // "purchasing_disabled": false,
        // "purchasing_disabled_message": "This item not available at this time.",
        "product_id": product_id,
        "sku": item.Sku,
        "inventory_level": inventory,
        "image_url":url,
        "option_values": optionValue
    };
     return await axios.post(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/variants`,data,{headers:storeInfo.headers});
};
export const deleteProduct = async(storeInfo,product_id)=>{
    return await axios.delete(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}`,{headers:storeInfo.headers});
};
export const deleteVariant = async(storeInfo,product_id,variant_id)=>{
    return await axios.delete(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/variants/${variant_id}`,{headers:storeInfo.headers});
};
export const deleteVariantOptionValue = async(storeInfo,product_id,option_id,value_id)=>{
    return await axios.delete(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/options/${option_id}/values/${value_id}`,{headers:storeInfo.headers});
};
export const getVariantOptionValue = async(storeInfo,product_id,option_id,value_id)=>{
    return await axios.get(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/options/${option_id}/values/${value_id}`,{headers:storeInfo.headers});
};
export const updateVariantOptionValue =  async(storeInfo,product_id,option_id,value_id,data)=>{
    return await axios.put(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/options/${option_id}/values/${value_id}`,data,{headers:storeInfo.headers});
};
export const addVariantOption = async (storeInfo ,item,product_id,colorList)=>{
    let colors='';
    let display_name;
    let option_values=[];
    if(colorList!==null){
        display_name = "Color";
        colorList.forEach((c,i)=>{
           const cc = findBestMatchColor(c.ColourOnline,commonColorList);
           option_values.push({
               "label": c.ColourOnline,
               "sort_order": (i+1),
               "value_data": {
                   "colors": [`${cc}`]
               },
               "is_default": false
           })
        });
    }else{
        if(item.ColorR !==undefined && item.ColorG !==undefined && item.ColorB !==undefined){
            colors=rgbToHex(parseInt(item.ColorR), parseInt(item.ColorG), parseInt(item.ColorB));
        }else{
            //HERE Change to swatch
            colors=(item.SwatchURL !== undefined ?item.SwatchURL:stringToHex(item.Color));
        }
        display_name = item.Material !==""?item.Material:"Color";
        const valueData = item.SwatchURL !== undefined ?{"image_url": `${item.SwatchURL}`}:{"colors": [`${colors}`]};
        option_values = [
            {
                "label": item.Color,
                "sort_order": 1,
                "value_data": valueData,
                "is_default": false
            }
        ]
    }
    const data = {
        "product_id": product_id,
        "display_name": display_name,
        "type": "swatch",
        "config": {
            "default_value": "text",
            "checked_by_default": false,
            "date_limit_mode": "earliest",
            "file_types_mode": "specific",
            "file_types_supported": [],
            "file_types_other": [],
            "text_min_length": 15,
            "text_max_length": 50,
            "text_lines_limited": true,
            "text_max_lines": 2,
            "number_limit_mode": "lowest",
            "product_list_adjusts_inventory": true,
            "product_list_adjusts_pricing": true,
            "product_list_shipping_calc": "none"
        },
        "option_values": option_values
    };
    //console.log(data);
    return await axios.post(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/options`,data,{headers:storeInfo.headers});

};
export const getImages = async(storeInfo,product_id)=>{
  return await axios.get(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/images`,{headers:storeInfo.headers});
};
export const addImage = async (storeInfo ,product_id,is_thumbnail,sort_order,description,image_url)=>{
    const data = {
        "is_thumbnail": is_thumbnail,
        "sort_order": sort_order,
        "description": description,
        "image_url": image_url
    };
    return await axios.post(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/images`,data,{headers:storeInfo.headers});
};
export const updateProductImage = async(storeInfo,product_id,image_id,is_thumbnail,data)=>{
    const res = await axios.post(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/images`,data,{headers:storeInfo.headers});
    if(res.status === 200 ){
        await axios.delete(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/images/${image_id}`,{headers:storeInfo.headers});
    }
    if(is_thumbnail){
        const updates = res.data.data;
        updates.is_thumbnail = true;
        await axios.put(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/images/${updates.id}`,updates,{headers:storeInfo.headers});
    }
    return res;
};
export const deleteProductImage = async(storeInfo,product_id,image_id)=>{
    return axios.delete(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/images/${image_id}`,{headers:storeInfo.headers});
};
export const updateVariantOption = async(storeInfo,product_id,option_id,data)=>{
    return await axios.put(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/options/${option_id}`,data,{headers:storeInfo.headers});
};
export const addVariantImage = async(storeInfo,product_id,variant_id,data)=>{
    return await axios.post(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/variants/${variant_id}/image`,data,{headers:storeInfo.headers});
};
export const updateProduct = async(storeInfo,product_id,data)=>{
    //console.log(data);
    return await axios.put(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}`,data,{headers:storeInfo.headers});
};

export const getBulkPricingRules = async(storeInfo,product_id)=>{
  return await axios.get(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/bulk-pricing-rules`,{headers:storeInfo.headers});
};
export const deleteBulkPricingRules = async(storeInfo,product_id,bulk_pricing_rule_id)=>{
    return await axios.delete(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/bulk-pricing-rules/${bulk_pricing_rule_id}`,{headers:storeInfo.headers});
};
export const updateBulkPricingRule = async(storeInfo,product_id,bulk_pricing_rule_id,data)=>{
    return await axios.put(`${BASE_URL}/${storeInfo.store_hash}/v3/catalog/products/${product_id}/bulk-pricing-rules/${bulk_pricing_rule_id}`,data,{headers:storeInfo.headers});
};
const componentToHex =(c)=> {
   const hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
};

const rgbToHex=(r, g, b)=> {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
};
const stringToHex = (str)=> {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let colour = '#';
    for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xFF;
        colour += ('00' + value.toString(16)).substr(-2);
    }
    return colour;
};
const commonColorList = [
    {"name":"WHITE", "value":"#FFFFFF"},
    {"name":"SILVER",	"value":"#C0C0C0"},
    {"name":"GRAY"	,"value":"#808080"},
    {"name":"BLACK",	"value":"#000000"},
    {"name":"RED",	"value":"#FF0000"},
    {"name":"MAROON",	"value":"#800000"},
    {"name":"YELLOW",	"value":"#FFFF00"},
    {"name":"OLIVE",	"value":"#808000"},
    {"name":"LIME",	"value":"#00FF00"},
    {"name":"GREEN",	"value":"#008000"},
    {"name":"AQUA",	"value":"#00FFFF"},
    {"name":"TEAL",	"value":"#008080"},
    {"name":"BLUE","value":	"#0000FF"},
    {"name":"NAVY","value":	"#000080"},
    {"name":"FUCHSIA",	"value":"#FF00FF"},
    {"name":"PURPLE","value":	"#800080"},
    {"name":"BRIT.TAN","value":	"#464334"},
];